import React, { useEffect, useState } from 'react';
import { DetailedAnalysisEmailParticipant } from '../../../../../../../store/deals/deals.types';

type Props = {
  participants?: {
    leftParticipant: DetailedAnalysisEmailParticipant;
    rightParticipant: DetailedAnalysisEmailParticipant;
  };
  sentiment?: number | null;
};

export const YourSentiment: React.FC<Props> = ({
  sentiment,
  participants,
}): JSX.Element => {
  const [measure, setMeasure] = useState<number | null>(null);

  useEffect(() => {
    const minValue = -1.5;
    const maxValue = 1.5;
    const middleValue = maxValue - minValue;

    const intermediateМalue =
      sentiment || sentiment === 0 ? sentiment - minValue : null;

    const result =
      intermediateМalue || intermediateМalue === 0
        ? (intermediateМalue / middleValue) * 100
        : null;

    if (result) {
      setMeasure(result);
    }
  }, [sentiment]);

  const defineSenderName = () => {
    let name = '';
    if (participants?.leftParticipant?.isSender) {
      if (participants.leftParticipant?.isUser) {
        name = 'My';
      } else {
        name = `${
          participants?.leftParticipant?.metadata?.name?.split(' ')[0]
        }'s`;
      }
    } else if (participants?.rightParticipant?.isSender)
      if (participants.rightParticipant?.isUser) {
        name = 'My';
      } else {
        name = `${
          participants?.rightParticipant?.metadata?.name?.split(' ')[0]
        }'s`;
      }
    return name;
  };

  const titleName = `${defineSenderName()} Sentiment`;

  const attrs = {
    wrapper: { className: 'your-sentiment' },
    header: { className: 'your-sentiment__header' },
    body: {
      wrapper: { className: 'your-sentiment__body' },
      negative: { className: 'your-sentiment__body-negative' },
      positive: { className: 'your-sentiment__body-positive' },
      barSection: {
        wrapper: { className: 'your-sentiment__body__bar-section' },
        bar: { className: 'your-sentiment__body__bar-section-bar' },
        circle: {
          className: 'your-sentiment__body__bar-section-circle',
          style: { left: `${measure}%` || '50%' },
        },
        centralStripe: {
          className: 'your-sentiment__body__bar-section-stripe',
        },
      },
    },
  };
  return (
    <div {...attrs.wrapper}>
      <div {...attrs.header}>{titleName}</div>
      <div {...attrs.body.wrapper}>
        <span {...attrs.body.negative}>Negative</span>
        <div {...attrs.body.barSection.wrapper}>
          <div {...attrs.body.barSection.centralStripe} />
          <div {...attrs.body.barSection.bar} />
          <div {...attrs.body.barSection.circle} />
        </div>
        <span {...attrs.body.positive}>Positive</span>
      </div>
    </div>
  );
};
